import { useMutation } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { BackupAzureModel } from '../types';

import { buildUrl } from './backupSettings.service';

export function useTestAzureConnectionMutation() {
  return useMutation(testAzureConnection, {
    ...withError('Unable to connect to Azure Blob Storage'),
  });
}

async function testAzureConnection(payload: BackupAzureModel) {
  try {
    const { data } = await axios.post(buildUrl('azure', 'test'), payload);

    return data;
  } catch (e) {
    throw parseAxiosError(
      e as Error,
      'Unable to connect to Azure Blob Storage'
    );
  }
}
